import { Client, ChannelInfoEvent, BanListEvent, InviteListEvent, ExceptListEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType, tabType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class ChannelInfoEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.CHANNEL_INFO, (event: ChannelInfoEvent) => {
            const { channel, modes, raw_modes, raw_params, created_at, url } = event;

            const channelExists = this.tM.getTab(tabType.CHANNEL, channel);
            let targetTab = this.tM.getStatusTab();
            if (channelExists) { targetTab = channelExists; }

            if (created_at) {
                const date = new Date(created_at * 1000)
                    .toLocaleDateString(
                        'en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                });
                this.mH.addMessage(targetTab, `* ${channel} created on ${date}`, IRCMessageType.SYSTEM);
            }
            if (raw_modes) {
                this.mH.addMessage(targetTab, `* ${channel} modes: [${raw_modes}]`, IRCMessageType.SYSTEM);
            }

            

        });

        this.client.on(IRC_EVENT.BANLIST, (event: BanListEvent) => {
            const { channel, bans } = event;
            this.mH.addMessage(this.tM.getStatusTab(),
                `[Unhandled] ${IRC_EVENT.BANLIST}: ${JSON.stringify(event)}`, IRCMessageType.ERROR);
        });

        this.client.on(IRC_EVENT.INVITELIST, (event: InviteListEvent) => {
            const { channel, invites } = event;
            this.mH.addMessage(this.tM.getStatusTab(),
                `[Unhandled] ${IRC_EVENT.INVITELIST}: ${JSON.stringify(event)}`, IRCMessageType.ERROR);

        });

        this.client.on(IRC_EVENT.EXCEPTLIST, (event: ExceptListEvent) => {
            const { channel, excepts } = event;
            this.mH.addMessage(this.tM.getStatusTab(),
                `[Unhandled] ${IRC_EVENT.EXCEPTLIST}: ${JSON.stringify(event)}`, IRCMessageType.ERROR);

        });
    }
}